module.exports = __webpack_public_path__ + "static/turquia-023-c2567387c436ddb588f388b5612d61e7.jpg";